<template>
	<div>
		<el-carousel :height="isMobile?'23vh':'65vh'">
			<el-carousel-item v-for="(item,index) in data" :key="index" :style="isMobile?'height: 23vh;':'height: 65vh;'">
				<el-image @click="openLink(item.link)" class="transition-normal fadeIn animated" style="width: 100vw;cursor: pointer;" :src="item.image"  :style="isMobile?'height: 23vh;':'height: 65vh;'"
					fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
		<!-- <div style="position: relative;" v-if="data" @touchstart="touchStart" @touchend="touchEnd">
			<div style="position: absolute;left: 0;top: 0;z-index: -1;width: 100vw;height: 80vh;overflow: hidden;">
				<div style="position: relative;display: flex" :style="{marginLeft:'-'+active*100+'vw'}"
					class="transition-normal">
					<div :style="{backgroundImage: 'url('+item.image+')'}" class="" v-for="(item, index) in data"
						:key="index"
						style="min-width: 100vw;height: 80vh;background-size:cover; background-repeat: no-repeat;background-position: top center ;">
					</div>
				</div>
			</div>

			<div style="position: absolute;left: 0;bottom: -2rem;width: 100%;">
				<div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
					<div style="display: flex;align-items: center;justify-content: center;margin-top: 2rem;">
						<div style="width: 0.5rem;height: 0.5rem;border-radius: 50%;margin: 0 0.3rem;cursor: pointer;"
							v-for="i in data.length" :key="i"
							:style="{backgroundColor: i-1==active?'#31ffda':'#a4a4a4'}" @click="clickcircle(i)"></div>
					</div>
				</div>
			</div> -->

	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// loading:false
				data: {
					carousels: []
				},
				active: 0,
				bannerleft: 0,
				bannerright: 0,

				touchStartX: 0,
				touchStartY: 0,
				delta: 50,
				bannerbtnshow: false,
				isMobile: false,
				t: null
			}
		},
		components: {},
		filters: {},
		methods: {
			openLink(url){
				window.open(url)
			},
			clickcircle(i) {
				this.active = i - 1
				clearInterval(this.t)
			},
			toviews() {
				let url = this.data.carousels[this.active].link
				location.href = url
			},
			touchStart(e) {
				console.log("触摸开始")
				this.touchStartX = e.touches[0].clientX;
				this.touchStartY = e.touches[0].clientY;
			},
			touchEnd(e) {
				console.log("触摸结束")
				let deltaX = e.changedTouches[0].clientX - this.touchStartX;
				let deltaY = e.changedTouches[0].clientY - this.touchStartY;
				console.info('sx', this.touchStartX)
				console.info('ex', deltaX)
				// X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
				if (Math.abs(deltaX) > this.delta && Math.abs(deltaX) > Math.abs(deltaY)) {
					if (deltaX >= 0) {
						console.log("右滑")
						this.prebanner()
					} else {
						console.log("左滑")
						this.nextbanner()
					}
					// Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
				} else if (Math.abs(deltaY) > this.delta && Math.abs(deltaX) < Math.abs(deltaY)) {
					if (deltaY < 0) {
						console.log("上滑")
					} else {
						console.log("下滑")
					}
					// 两轴位移都特别小，可以判断是点击
				} else if (Math.abs(deltaY) < 25 && Math.abs(deltaX) < 25) {
					this.bannerbtnshow = true
					console.log("点击")
				} else {
					console.log("可能是误触")
				}
			},
			getData() {
				this.request({
					url: '/gci/index',
					method: 'get'
				}).then(res => {
					// let { code, data, message } = res.data
					console.info('banner', res.data)
					this.data = res.data.productBanners
					// this.$bus.$emit('loading', false)
				}).catch(error => {
					console.error(error.response)
				})
			},
			prebanner() {
				if (this.active > 0) {
					this.active--
				}
			},
			nextbanner() {
				if (this.active < this.data.carousels.length - 1) {
					this.active++
				}
			},
			bannerleftbtn(i) {
				this.bannerleft = i
			},
			bannerrightbtn(i) {
				this.bannerright = i
			}
		},
		mounted() {
			localStorage.getItem('isMobile') == 'null' ? this.isMobile = false : this.isMobile = true
			this.getData()
			// new WOW().init();

		},
		beforeDestroy() {
			clearInterval(this.t)
		}
	}
</script>

<style scoped lang="scss">
	/deep/ .el-carousel__container{
		height: 65vh;
	}
	.banner {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 8rem;

		.banner-box {
			padding: 0 4.375rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 70vw;
			height: 34rem;

			.banner-title {
				font-size: 3.75rem;
				color: #FFFFFF;
				line-height: 5.625rem;
				font-weight: bold;
				text-align: center;
			}

			.banner-dec {
				margin-top: 2.5rem;
				font-size: 1.375rem;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 2.25rem;
				text-align: center;
				white-space: pre-wrap
			}
		}
	}

	.banner-button {
		width: 10rem;
		height: 2.8125rem;
		border-radius: 2.9375rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 500;
		color: #000000;
		line-height: 0px;
		font-size: 1.375rem;
		margin-top: 4.0625rem;
	}

	.banner-bottom {
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
	}

	.slide-btn {
		cursor: pointer
	}

	.transition-normal {
		transition: all 1s cubic-bezier(.02, .01, .47, 1);
	}

	@media (max-width: 767px) {
		.banner {
			padding-top: 7rem;

			.slide-btn {
				// display: none
				position: absolute;
				top: 20rem;
			}


			.banner-box {
				line-height: 1;
				padding: 1rem;
				width: 80rem;
				height: 30rem;

				.banner-title {
					line-height: 1.5;
					font-size: 1.5rem;
				}

				.banner-dec {
					font-size: 1rem;
				}
			}
		}
	}
</style>